export default {
    title: 'Assistant',
    launcher: {
        label: 'AI Assistant',
        // The pill is collapsed to its icon most of the time, so the whole
        // sentence lives in the tooltip rather than on the button.
        hint: 'Create a wig by voice',
    },
    newConversation: 'New conversation',
    closeConfirm: {
        // The card is not at risk — say so, or the question reads as if closing
        // would undo the work.
        text: 'Close the assistant? The conversation ends here. Any card it created stays in Draft.',
        yes: 'Close',
        no: 'Keep talking',
    },
    composer: {
        placeholder: 'Describe the wig, or press the microphone',
        send: 'Send',
        record: 'Record',
        stop: 'Stop',
        cancel: 'Cancel',
        recording: 'Recording',
        working: 'The assistant is working…',
    },
    chat: {
        greeting: 'Hi! I’m Yafi Assistant. How can I help you?',
        heard: 'Heard',
        // Screen-reader label for the three dots while a recording is being
        // turned into words.
        transcribing: 'Transcribing the recording',
    },
    candidates: {
        title: 'Which client?',
        hint: 'Choose the client yourself — the assistant never picks one.',
        select: 'Choose',
        // Travels as the turn's `text`, not just as a label — and its language
        // is what the assistant answers in. `client` is the name, and the phone
        // beside it when the candidate has one.
        sentText: '{client} — that one, please.',
    },
    pendingClient: {
        title: 'Create this client?',
        confirm: 'Yes, use this client',
        // Confirming may return an existing client rather than a new one.
        note: 'If this phone is already in the system, the existing client will be used.',
        // The consent is a field on the request that only this button attaches,
        // so a typed "yes" can never work.
        onlyButton: 'Only this button confirms it — typing “yes” will not.',
        sentText: 'Yes, create that client.',
    },
    // A wig the assistant listed, drawn as a card in the message.
    card: {
        repair: 'Repair',
        // How long the card has stood still. Never a deadline: there is no due
        // date in the database, and wording one here would invent it.
        stalled: 'untouched {age}',
        ageDays: '{days} d.',
        ageMonths: '{months} mo.',
        ageYears: 'over {years} y.',
        more: 'Showing {shown} of {total} — ask for the rest',
    },
    wig: {
        title: 'Draft card',
        open: 'Open card',
        // Free text the assistant could not place in a field — what is still to
        // be sorted out, not leftovers.
        details: 'Still to sort out',
        limits: 'Price, barcode and moving out of Draft stay with you. The assistant does not do repairs.',
    },
    // Keys match the values of ASSISTANT_FAILURES: the type is the key.
    errors: {
        ['gateway_down']:
            'The assistant is not answering right now. It is worth trying again.',
        ['switched_off']: 'The assistant is switched off.',
        ['forbidden']: 'Your role does not have access to the assistant.',
        ['not_found']: 'This conversation was not found.',
        ['validation']: 'That message could not be sent.',
        ['network']: 'The request did not reach the server.',
        ['unknown']: 'Something went wrong.',
        retry: 'Try again',
    },
    // Keys match the values of RECORDER_ERRORS: the reason is the key.
    recorder: {
        ['permission_denied']:
            'Allow access to the microphone in your browser to dictate.',
        ['no_device']: 'No microphone was found.',
        ['unsupported']:
            'This browser cannot record audio. Type the description instead.',
        ['insecure_context']: 'Recording needs a secure connection (https).',
        ['too_large']:
            'The recording is too long — it has to stay under 25 MB.',
        ['empty']: 'Nothing was recorded.',
        ['unknown']: 'The recording could not be made.',
    },
}
